import styled from 'styled-components';
import { PaperContent } from 'view/layout/paper';

// eslint-disable-next-line rulesdir/no-styled-export
export const AnnouncementInnerContainer = styled(PaperContent)`
    /* Reset top padding from the paper content. */
    padding-top: 0;
`;
